import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SetupWizard } from '../../components/onboarding/SetupWizard';
import { useAuthStore } from '../../store/authStore';
import { useSetupStatus } from '../../hooks/useSetupStatus';

export function SetupPage() {
  const navigate = useNavigate();
  const escolaId = useAuthStore((s) => s.user?.escolaId);
  const { prontoParaOperar } = useSetupStatus({ routePrefix: '/admin' });

  useEffect(() => {
    const storageKey = escolaId ? `ac_wizard_concluido_${escolaId}` : null;
    const isCompleted = storageKey ? localStorage.getItem(storageKey) === 'true' : false;
    if (isCompleted && prontoParaOperar) {
      // Setup já foi concluído e finalizado anteriormente
      navigate('/admin/dashboard', { replace: true });
    }
  }, [escolaId, prontoParaOperar, navigate]);

  return (
    <div className="sw-dashboard-host">
      <SetupWizard />
    </div>
  );
}
